import React from 'react';
import ProdPlanGridItemMini from './ProdPlanGridItemMini';
import ProdPlanGridItemPhoto from './ProdPlanGridItemPhoto';
import ProdPlanGridItemPopup from './ProdPlanGridItemPopup';
import { getShowDocumentLink, getSizedImageUrl } from '../../../../../helper/uiFunctions';
import { Icon } from '../../../../../library/decor/SarasIcons';

const ProdPlanGridItem = ({ viewData, calendarControl, isTabletWidthOrLess, onMoveDate }) => {
    const popupAnchorRef = React.useRef(null);
    const [isPopupOpen, setIsPopupOpen] = React.useState(false);
    const displayMode = calendarControl?.getSetting
        ? calendarControl.getSetting('displayMode', 'mini')
        : 'mini';
    const canMoveDate = !calendarControl?.isCalendarReadOnly;
    const documentTypeId = viewData?.dtid || 0;
    const documentId = viewData?.did || 0;
    const OpenInNew = Icon['next'];
    const triggerSize = isTabletWidthOrLess ? 32 : 20;
    const triggerIconSize = isTabletWidthOrLess ? 18 : 14;
    const triggerInset = isTabletWidthOrLess ? 4 : 6;

    const onOpenDocument = React.useCallback(() => {
        const documentLink = getShowDocumentLink(documentTypeId, documentId, '', 1, 'prod', 'order');
        if (!documentLink) return;

        window.open(documentLink, '_blank');
    }, [documentTypeId, documentId]);

    const onOpenLargeImage = React.useCallback(() => {
        const largeImageUrl = getSizedImageUrl(viewData?.itemImage?.url || '', 'L');
        if (!largeImageUrl) return;

        window.open(largeImageUrl, '_LargeImage');
    }, [viewData]);

    const commonProps = {
        viewData,
        calendarControl,
        onOpenDocument,
        onOpenLargeImage
    };

    let body = <ProdPlanGridItemMini {...commonProps} />;

    if (displayMode === 'photo') {
        body = <ProdPlanGridItemPhoto {...commonProps} />;
    }

    return (
        <>
            <button
                ref={popupAnchorRef}
                type='button'
                onClick={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    setIsPopupOpen((previous) => !previous);
                }}
                style={{
                    position: 'absolute',
                    top: `${triggerInset}px`,
                    right: `${triggerInset}px`,
                    zIndex: 2,
                    width: `${triggerSize}px`,
                    height: `${triggerSize}px`,
                    padding: '0',
                    border: 'none',
                    borderRadius: '50%',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: 'rgba(255, 255, 255, 0.94)',
                    color: '#5f7088',
                    boxShadow: '0 1px 4px rgba(15, 23, 42, 0.14)',
                    cursor: 'pointer'
                }}
                title='Open planning details'
            >
                <OpenInNew style={{ fontSize: `${triggerIconSize}px` }} />
            </button>
            {body}
            {isPopupOpen ? (
                <ProdPlanGridItemPopup
                    anchorRef={popupAnchorRef}
                    open={isPopupOpen}
                    onClose={() => {
                        setIsPopupOpen(false);
                    }}
                    viewData={viewData}
                    canMoveDate={canMoveDate}
                    onMoveDate={onMoveDate}
                />
            ) : null}
        </>
    );
};

export default ProdPlanGridItem;
